export default __webpack_public_path__ + "static/media/forward.51e072c6.webp";